import http from "../../http-common";

const filterReceipt = (data) => {
    return http.post("/ReceiptProduct/FilterReceipt", data);
};

const cancelReceipt = (data) => {
    return http.post("/ReceiptProduct/CancelReceipt", data);
};

const getById = (data) => {
    return http.post("/ReceiptProduct/GetById", data);
};

const filterOutput = (data) => {
    return http.post("/OutputProduct/FilterOutput", data);
};

const cancelOutput = (data) => {
    return http.post("/OutputProduct/CancelOutput", data);
};

const getByIdOutput = (data) => {
    return http.post("/OutputProduct/GetById", data);
};

export default {
    filterReceipt, getById, cancelReceipt, filterOutput, cancelOutput, getByIdOutput
};
